import React from "react";
import {
  Table as AntTable,
  Space,
  Popconfirm,
  Input,
  Button,
  Modal,
} from "antd";
import { useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { genNumberTable } from "../../../../function/genNumberTable";
import { useStateContext } from "../../../../contexts/ContextProvider";
import DetailsModal from "../../Input/components/DetailsModal.jsx";

const headerStyle = {
  color: "white",
  fontWeight: "bold",
  backgroundColor: "black",
};

const TableMapInput = ({ data, onEdit, loading, isHistory = false, onRejectCancel,auditRecord,refetch }) => {
  const [setSearchText] = useState("");
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const onMapconfirm = (record) => {
    const payload = {
      inputId: record.id,
      auditId: auditRecord.id,
    };
    onEdit(payload);
    refetch();
  };

  const columns = [
    {
      title: "Map",
      key: "map",
      align: "center",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
      render: (_, record) => (
        <Popconfirm
          title="Are you sure to map this item?"
          onConfirm={() => onMapconfirm(record)}
          okText="Yes"
          cancelText="No"
        >
          <Button>Map</Button>
        </Popconfirm>
      ),
    },
    {
      title: "ลำดับ",
      align: "center",
      //width: 60,
      dataIndex: "number",
      key: "number",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
    {
      title: "CaseName",
      align: "center",
      dataIndex: "caseName",
      key: "caseName",
      //width: 90,
      onHeaderCell: () => {
        return { style: headerStyle };
      },
      render: (caseName) => {
        const getCaseNameColor = (caseName) => {
          switch (caseName) {
            case 'deposit':
              return 'green';
            case 'withdraw':
              return 'red';
            case 'ETC':
              return 'purple';
            case 'transfer':
              return 'purple';
            default:
              return 'black';
          }
        };
        return <span style={{ fontSize: '16px', fontWeight: 'bold', color: getCaseNameColor(caseName) }}>{caseName.toUpperCase()}</span>;
      },
    },
    {
      title: "UserId",
      align: "center",
      dataIndex: "userId",
      key: "userId",
      //width: 90,
      onHeaderCell: () => {
        return { style: headerStyle };
      },
    },
    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      //width: 120,
      key: "status",
      onHeaderCell: () => {
        return { style: headerStyle };
      },
      render: (status) => {
        const getStatusColor = (status) => {
          switch (status) {
            case 'Success':
              return 'green'; // เหลืองส้ม
            case 'Reject':
              return 'red'; // bright red
            case 'Inform':
              return '#fa8c16'; // ส้ม — ขอข้อมูลเพิ่ม ไม่ใช่ความผิด
            case 'Pending':
              return '#ffa500'; // bright orange
            case 'Waiting':
              return 'blue'; // bright blue
            default:
              return '#000000'; // black
          }
        };

        return (
          <span style={{
            color: getStatusColor(status),
            // fontWeight: 'bold',
            fontSize: '16px',
            //backgroundColor: getStatusColor(status),
          }}>
            <span style={{
              display: 'inline-block',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: getStatusColor(status),
              marginRight: '4px',
            }}></span>
            {status || "-"}
            <span style={{
              display: 'inline-block',
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: getStatusColor(status),
              marginLeft: '4px',
            }}></span>
          </span>
        );
      },
    },
    {
      title: "วันที่อัพเดตล่าสุด",
      align: "center",
      dataIndex: "lastUpdateDate",
      key: "lastUpdateDate",
      onHeaderCell: () => ({ style: headerStyle }),
      render: (lastUpdateDate) => {
        return <span>{lastUpdateDate}</span>;
      },
    },
    {
      title: "สร้างโดย",
      align: "center",
      key: "create_by_name",
      dataIndex: "create_by_name",
      onHeaderCell: () => ({ style: headerStyle }),
    },
    {
      // แถว Inform เก็บเหตุผลไว้ที่ inform_remark คนละคอลัมน์กับ reject_remark
      title: "เหตุผลที่ตีกลับ",
      align: "center",
      key: "return_remark",
      onHeaderCell: () => ({ style: headerStyle }),
      render: (_, record) => (
        <span>
          {(record.status === 'Inform' ? record.inform_remark : record.reject_remark) || '-'}
        </span>
      ),
      width: 150,
    },
    {
      title: "Note.",
      align: "center",
      onHeaderCell: () => ({ style: headerStyle }),
      render: (record) => {
        // ตรวจสอบว่า customFields เป็น array ก่อนใช้ find เพื่อป้องกัน Uncaught TypeError
        let note = null;
        const customFields = record?.dataManage?.customFields;
        if (Array.isArray(customFields)) {
          note = customFields.find((field) => field.title === "NOTE.")?.value ?? null;
        }
        return <span>{note}</span>;
      },
      width: 150,
    },
    {
      title: "รูปภาพ",
      align: "center",
      key: "images",
      //width: 50,
      onHeaderCell: () => ({ style: headerStyle }),
      render: (record) => {
        if (!record.imgRecipe || !Array.isArray(record.imgRecipe) || record.imgRecipe.length === 0 || record.imgRecipe[0].img_url === null) {
          return "-";
        }

        return (
          <Button
            type="primary"
            onClick={() => {
              Modal.info({
                title: "รูปภาพ",
                width: 800,
                content: (
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                      marginTop: "20px",
                    }}
                  >
                    {record.imgRecipe.map((image, index) => (
                      <div key={index} style={{ width: "200px" }}>
                        <img
                          src={image.img_url}
                          alt={`Image ${index + 1}`}
                          style={{
                            width: "100%",
                            height: "auto",
                            borderRadius: "4px",
                          }}
                        />
                      </div>
                    ))}
                  </div>
                ),
                okText: "ปิด",
              });
            }}
          >
            ดู
          </Button>

        );
      }
    },
    {
      title: "รายละเอียด",
      // fixed: "right",
      key: "details",
      align: "center",
      //width: 50,
      render: (record) => {
        if (record.status == 'Success' || record.status == 'Reject' || record.status == 'Pending' || record.status == 'RejectSuccess') {
          return (
            <Button
              type="default"
              width={50}
              onClick={() => {
                setSelectedRecord(record);
                setDetailsModalVisible(true);
              }}
            >
              ดู
            </Button>
          );
        }
        return null;
      },
      onHeaderCell: () => ({ style: headerStyle }),
    },
    ...(isHistory
      ? []
      : [
        {
          title: "การจัดการ",
          // fixed: "right",
          key: "actions",
          align: "center",
          //width: 100,
          render: (record) => (
            <Space size="middle">
              <Button
                type="primary"
                onClick={() => onEdit(record)}
              >
                แก้ไข
              </Button>
              <Button
                type="primary"
                onClick={() => onRejectCancel(record)}
              >
                Cancel Reject
              </Button>
            </Space>
          ),
          onHeaderCell: () => ({ style: headerStyle }),
        },
      ]),
  ];

  return (
    <div className="overflow-x-auto" style={{ minWidth: 0, maxWidth: '100%' }}>
      <AntTable
        loading={loading}
        className="border-1 rounded-lg border-gray-200"
        dataSource={genNumberTable(data)}
        columns={columns}
        scroll={{ x: 'max-content' }}
        bordered
        pagination={true}
        rowKey="id"
        pageSize={10}
        pageSizeOptions={[10, 20, 50, 100]}
        showSizeChanger={true}
        showQuickJumper={true}
        //rowSelection={rowSelection}

      />
      <DetailsModal
        visible={detailsModalVisible}
        onClose={() => {
          setDetailsModalVisible(false);
          setSelectedRecord(null);
        }}
        record={selectedRecord}
      />
    </div>
  );
};

export default TableMapInput;
